import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import config from '../../../../../config';
import { getAuthToken } from '../../../../utils/auth';
import styles from './ContentRow.module.css';
import ContentRowPrice from './ContentRowPrice';
import ContentRowTipJar from './ContentRowTipjar';
import usePriceSettings from './use-pricesettings';

const putArticleStateToggle = async (articleId, articleState) => {
  const accessToken = getAuthToken();

  let url;
  if (articleState) {
    url = `${config.ApiBaseUrl}/article/act/${articleId}`;
  } else {
    url = `${config.ApiBaseUrl}/article/deact/${articleId}`;
  }

  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const json = await response.json();

  const { message, success } = json;

  if (!success)
    throw new Error(
      message ?? 'Something went wrong. failed to process request'
    );

  return success;
};

const ContentRow = ({
  id,
  postTitle,
  isChecked,
  price,
  setArticles,
  tipJarPrice,
  category,
  monetizeType,
}) => {
  const {
    priceSettings,
    handlePaywallChange,
    handleTipJarChange,
    setIsEdited,
  } = usePriceSettings(id, price, tipJarPrice, postTitle);

  const articleToggleBtn = useRef();

  const handleToggleArticle = async () => {
    const success = await putArticleStateToggle(id, !isChecked);
    if (success) {
      setArticles((prevState) => {
        const articlesCopy = prevState.map((article) => {
          if (article.id === id) {
            // eslint-disable-next-line no-param-reassign
            article.isChecked = !article.isChecked;
          }

          return article;
        });
        return articlesCopy;
      });
    }
  };

  const tipJar = {
    low: priceSettings.tipJarPrice[0],
    med: priceSettings.tipJarPrice[1],
    high: priceSettings.tipJarPrice[2],
  };

  return (
    <tr className={styles['content-row']}>
      <td className={styles['content-row__title']}>{postTitle}</td>
      <td className={styles['content-row__toggle']}>
        <label className={styles.toggle__switch}>
          <input
            type="checkbox"
            checked={isChecked}
            onClick={handleToggleArticle}
            ref={articleToggleBtn}
          />
          <span
            className={`${styles['toggle__switch-slider']} ${styles['toggle__switch-round']}`}
          />
        </label>
      </td>
      {monetizeType === 'paywall' && (
        <td className={styles['content-row__price']}>
          <ContentRowPrice
            id={id}
            price={priceSettings.paywallPrice}
            onPaywallChange={(paywall) => handlePaywallChange(paywall)}
            setIsEdited={setIsEdited}
          />
        </td>
      )}
      {monetizeType === 'tipjar' && (
        <ContentRowTipJar
          id={id}
          tipJar={tipJar}
          onTipJarChange={(pTipJar) => handleTipJarChange(pTipJar)}
          setIsEdited={setIsEdited}
        />
      )}
      <td className={styles['content-row__category']}>{category}</td>
    </tr>
  );
};

ContentRow.propTypes = {
  id: PropTypes.node.isRequired,
  category: PropTypes.node.isRequired,
  price: PropTypes.node.isRequired,
  postTitle: PropTypes.node.isRequired,
  setArticles: PropTypes.node.isRequired,
  tipJarPrice: PropTypes.node.isRequired,
  isChecked: PropTypes.node.isRequired,
  monetizeType: PropTypes.node.isRequired,
};

export default ContentRow;
